import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { ToastProvider } from "./components/ToastNotifications";
import { ThemeProvider } from "./contexts/ThemeContext";
import Homepage from "./components/Homepage";
import Story from "./components/Story";
import Changelog from "./components/Changelog";
import ColorApp from "./components/ColorApp";
import LoadingScreen from "./components/LoadingScreen";

// Scroll restoration component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Immediately reset scroll position
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    // Also reset after a brief delay to ensure it sticks
    // This handles cases where the page transition might interfere
    const timeoutId = setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 100);

    return () => clearTimeout(timeoutId);
  }, [pathname]);

  return null;
}

// Animated routes wrapper
function AnimatedRoutes() {
  const location = useLocation();
  const [showLoadingScreen, setShowLoadingScreen] = useState(false);
  const [previousPath, setPreviousPath] = useState(location.pathname);

  useEffect(() => {
    const isNavigatingToApp = location.pathname === '/app' && previousPath !== '/app';
    const isFromWebsite = previousPath === '/' || previousPath === '/story' || previousPath === '/changelog';

    if (isNavigatingToApp && isFromWebsite) {
      setShowLoadingScreen(true);

      // Hide loading screen after 3 seconds
      const timer = setTimeout(() => {
        setShowLoadingScreen(false);
      }, 3000);

      return () => clearTimeout(timer);
    }

    setPreviousPath(location.pathname);
  }, [location.pathname, previousPath]);

  return (
    <>
      <LoadingScreen isLoading={showLoadingScreen} />
      <AnimatePresence mode="wait" initial={false}>
        <Routes location={location} key={location.pathname}>
          <Route path="/" element={<Homepage />} />
          <Route path="/story" element={<Story />} />
          <Route path="/changelog" element={<Changelog />} />
          <Route path="/app" element={<ColorApp />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

const App = () => {
  return (
    <Router>
      <ScrollToTop />
      <ToastProvider>
        <ThemeProvider>
          <AnimatedRoutes />
        </ThemeProvider>
      </ToastProvider>
    </Router>
  );
};

export default App;